import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ customerReference3: string }>;

export const DispatchcustomerReference3: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/CustomerReference3",
        customerReference3: props.parameter.customerReference3,
    });
};

export const chain = [DispatchcustomerReference3];

const setcustomerReference3 = createHandlerChainRunner(chain, "customerReference3");
export default setcustomerReference3;
